export class DiscussionObjectTypeConstants {
  public static readonly ACTIVITY = "Activity";

  public static readonly ACTIVITY_HISTORY = "Activity History";

  public static readonly DEAL = "Deal";

  public static readonly WORKFLOW_TASK = "Workflow Task";
}
